import React from 'react';
import {
    FormTab,
    TextInput,
    ReferenceInput,
    AutocompleteInput,
    NumberInput,
    DateInput,
    BooleanInput,
} from 'react-admin';

import Create from '../common/views/Create';
import TabbedForm from '../common/forms/TabbedForm';
import BudgetTypeInput from './inputs/BudgetTypeInput';

const optionText = choice => (choice && choice.name ? choice.name : '');

const BudgetCreate = props => (
    <Create {...props}>
        <TabbedForm redirect="list">
            <FormTab label="summary">
                <ReferenceInput label="Customer" source="customer_id" reference="customers" sort={{ field: 'name', order: 'ASC' }} allowEmpty>
                    <AutocompleteInput optionText={optionText} />
                </ReferenceInput>

                <ReferenceInput label="Project" source="project_id" reference="projects" sort={{ field: 'name', order: 'ASC' }} allowEmpty>
                    <AutocompleteInput optionText={optionText} />
                </ReferenceInput>

                <BudgetTypeInput />

                <TextInput source="label" />
                <TextInput source="alias" />
                <TextInput source="description" />

                <NumberInput source="hours_included" />
                <NumberInput source="amount" />

                <DateInput source="start_date" />
                <DateInput source="end_date" />

                <BooleanInput source="is_active" defaultValue={true} />
            </FormTab>
        </TabbedForm>
    </Create>
);

export default BudgetCreate;